import { MSG91 } from "../utils/constants";

export class Msg91Service {
  static OTP_CHANNEL = {
    SMS: "11",
    WHATSAPP: "12",
  };
  static OTP_CHANNEL_NAME = {
    [this.OTP_CHANNEL.SMS]: "SMS",
    [this.OTP_CHANNEL.WHATSAPP]: "WhatsApp",
  };
  static isInitialized = false;
  static init() {
    if (this.isInitialized) {
      return;
    }
    const configuration = {
      widgetId: MSG91.WIDGET_ID,
      tokenAuth: MSG91.TOKEN_AUTH,
      // captchaRenderId: 'captchaRenderId',
      exposeMethods: true,
      success: (data) => {
        // get verified token in response
        console.log('msg91 init success response', data);
    },
    failure: (error) => {
        // handle error
        console.log('msg91 init failure reason', error);
    },
    }
    window.initSendOTP(configuration);
    this.isInitialized = true;
  }
  static phoneNumber(phone) {
    return phone.length === 10 ? `91${phone}` : phone;
  }

  static async sendOtp({ phone, channel = this.OTP_CHANNEL.WHATSAPP }) {
    console.log("Msg91Service.sendOtp", phone, channel);
    this.init();
    if (!window.sendOtp) {
      throw new Error("window.sendOtp is not defined");
    }
    return new Promise((resolve, reject) => {
      window.sendOtp?.(
        this.phoneNumber(phone),
        (data) => {
          console.log("Msg91Service.sendOtp", data);
          if (data.type === "success") {
            resolve({
              messageId: data.message,
            });
          } else {
            reject(data.message);
          }
        },
        (error) => {
          console.log("Msg91Service.sendOtp error", error);
          reject(error.message);
        },
        channel
      );
    });
  }

  static async verifyOtp({ otp, messageId }) {
    if (!window.verifyOtp) {
      throw new Error("window.verifyOtp is not defined");
    }
    return new Promise((resolve, reject) => {
      window.verifyOtp?.(
        otp,
        (data) => {
          console.log("Msg91Service.verifyOtp", data);
          if (data.type === "success") {
            resolve({
              otpToken: data.message,
            });
          } else {
            reject(data.message);
          }
        },
        (error) => {
          console.log("Msg91Service.verifyOtp error", error);
          reject(error.message);
        },
        messageId
      );
    });
  }

  static async retryOtp({ messageId, channel = this.OTP_CHANNEL.WHATSAPP }) {
    console.log("Msg91Service.retryOtp", messageId, channel);
    if (!window.retryOtp) {
      throw new Error("window.retryOtp is not defined");
    }
    return new Promise((resolve, reject) => {
      window.retryOtp?.(
        channel,
        (data) => {
          console.log("Msg91Service.retryOtp", data);
          if (data.type === "success") {
            resolve({
              messageId: data.message,
            });
          } else {
            reject(data.message);
          }
        },
        (error) => {
          console.log("Msg91Service.retryOtp error", error);
          reject(error.message);
        },
        messageId
      );
    });
  }
}
